import { CardStatus } from '../../Prototype/Level/Card/CardStatus';
import { CardType } from '../../Prototype/Level/Card/CardType';
import Component from '../Component';

export default class CardComponent extends Component {
    public type: CardType = undefined;
    public value?: number = undefined;
    public random?: boolean = undefined;
    public depth?: number = undefined;
    public sequence?: number = undefined;
    public faceUp: boolean = false;
    public x: number = 0;
    public y: number = 0;
    public rotation: number = 0;
    public attempts: number = 0;
    public currentStatus: CardStatus = CardStatus.UNKNOWN;
    public animating: boolean = false;
}
